import React, { useState } from "react";
import { Row, Col, Button, Modal } from "react-bootstrap";

const YesAndNoModal = (props) => {
  const [ShowModal, setShowModal] = useState(props.showmodal);
  const [Content, setContent] = useState(props.message);
  const [ModalType, setModalType] = useState(props.modaltype);
  let errorbackground = {
    backgroundColor: "#f04e00",
    fontFamily: "Times New Roman",
  };
  let successbackground = {
    backgroundColor: "#00ca65",
    fontFamily: "Times New Roman",
  };
  const [errorBackStyle, seterrorBackStyle] = useState(errorbackground);
  const [successBackStyle, setsuccessBackStyle] = useState(successbackground);

  return (
    ShowModal && (
      <Modal
        show={ShowModal}
        onHide={props.NextEvent}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header
          style={ModalType === "Error" ? errorBackStyle : successBackStyle}
          closeButton
        >
          <Modal.Title>
            {ModalType === "Error" ? "Confirm Action" : "Success"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            fontFamily: "Times New Roman",
          }}
        >
          {Content}
        </Modal.Body>
        <Modal.Footer>
          <Row>
            <Col md={4}>
              <Button variant="secondary" onClick={props.deletereceipt}>
                YES
              </Button>
            </Col>
            <Col md={4}>
              <Button variant="secondary" onClick={props.NextEvent}>
                CANCEL
              </Button>
            </Col>
          </Row>
        </Modal.Footer>
      </Modal>
    )
  );
};

export default YesAndNoModal;
